import { useQuery } from 'react-query';
import { EquipmentService } from 'src/services';

export const useEquipment = () => {
  const equipment = useQuery(
    'equipment',
    EquipmentService.getAll,
    {
      staleTime: Infinity
    }
  );
  return equipment.data ?? null;
};
